import { createClient } from '@supabase/supabase-js';


// Pegue essas informações no seu painel do Supabase:
// Vá em "Project Settings" (ícone de engrenagem) > "API"
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);